module.exports = __webpack_public_path__ + "img/Microsoft-badge-background.55847cfa.jpeg";